import { Params } from '@angular/router';
import { GAMESHOW_ROUTE } from 'app/teacher/gameshow/constants/gameshow-routing.constants';
import { DYNAMIC_GROWTH_REPORT_ROUTE } from 'app/teacher/growth-reports/dynamic-growth-report/dynamic-growth-report-routing.constants';
import { GROWTH_REPORT_ROUTE } from 'app/teacher/growth-reports/growth-report/growth-report-routing.constants';
import { MISSION_REPORT_EDIT_ROUTE, MISSION_REPORT_ROUTE } from 'app/teacher/mission-report/mission-report-routing.constants';
import { DYNAMIC_MISSION_REPORT_ROUTE } from 'app/teacher/mission-reports/dynamic-mission-report/dynamic-mission-report-routing.constants';
import { GAME_SHOW_REPORT_ROUTE } from 'app/teacher/mission-reports/game-show-report/game-show-report-routing.constants';
import { RECENT_ACTIVITY_ROUTE } from 'app/teacher/recent-activity/recent-activity-routing.constant';
import { ACTIVITIES_ROUTE } from 'app/teacher/routing-constants/activities-routing.constants';
import { TEACHER_REPORTS_ROUTE } from 'app/teacher/routing-constants/teacher-reports-routing.constant';
import { STUDENT_SUMMARY_ROUTE } from 'app/teacher/student-summary/student-summary-routing.constant';
import { STUDENTS_ROUTE } from 'app/teacher/students/students-routing.constant';
import { CONTENT_ROUTE } from '../content/content-routing.constants';
import { STUDENT_GAP_ROUTE } from 'app/teacher/student-gap/student-gap-routing.constant';
import { STUDENT_GAPS_ROUTE } from 'app/teacher/student-gaps/student-gaps-routing.constants';
import { SEND_CHEER_ROUTE } from 'app/teacher/send-cheer/send-cheer-routing.constant';
import { HELP_REQUESTS_ROUTE } from 'app/teacher/help-requests/help-request-routing.constant';
import { MATHALON_ROUTE } from 'app/teacher/mathalon/mathalon-routing.constant';
import { LIVE_MODE_ROUTE } from "app/teacher/live-mode/live-mode-routing.constats";
import { PARENTS_ROUTE } from 'app/teacher/parents/parents-routing.constant';
import { PORTFOLIO_ROUTE } from "app/teacher/portfolio/portfolio-routing.constant";
import { PLC_ROUTE } from 'app/routing-constants/plc-routing.constant';
import { GAME_SHOW_ROUTE } from 'app/teacher/game-show/game-show-routes.constants';

export const TEACHER_ROUTE = {
  name: 'teacher',
  route(): string[] {
    return ['/', this.name];
  },

  DEFAULT: '',

  ACTIVE_CLASS: {
    name: ':classId',
    route(classId: string): string[] {
      return [...TEACHER_ROUTE.route(), classId];
    }
  },

  // the underlying route would need to be re-set but just adding for external guard
  PLC: PLC_ROUTE,

  ACTIVITIES: ACTIVITIES_ROUTE,

  CLASS_SETTINGS: {
    name: 'settings',
    route(classId: string): string[] {
      return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), this.name];
    }
  },

  CONTENT: CONTENT_ROUTE,

  COURSE_CONTENT_UNIT: {
    baseName: 'coursecontent',
    name: 'coursecontent/:pageMode/:publicUnitId',
    route(classId: string, publicUnitId: string, pageMode = ''): string[] {
      return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), 'coursecontent', pageMode, publicUnitId];
    }
  },

  DYNAMIC_GROWTH_REPORT: DYNAMIC_GROWTH_REPORT_ROUTE,

  GAMESHOW: GAMESHOW_ROUTE,

  GAME_SHOW: GAME_SHOW_ROUTE, // this is the new game show route

  GAMESHOW_REPORT: GAME_SHOW_REPORT_ROUTE,

  GAMESHOWS: {
    name: 'gameshows',
    route(classId: string): string[] {
      return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), this.name];
    },

    ITEM: {
      name: ':folderId',
      route(classId: string, folderId: string): string[] {
        return [...TEACHER_ROUTE.GAMESHOWS.route(classId), folderId];
      }
    },

    SHARED: {
      name: 'shared/:sharedFolderId/:folderId',
      route(classId: string, sharedFolderId: string, folderId: string): string[] {
        return [...TEACHER_ROUTE.GAMESHOWS.route(classId), 'shared', sharedFolderId, folderId];
      },
    },

    CURRICULUM: {
      name: 'curriculum', //  available query params courseid;branchid;searchvalue;localeid;countrycode;regioncode
      route(classId: string): string[] {
        return [...TEACHER_ROUTE.GAMESHOWS.route(classId), this.name];
      },
    },

    FEATURED: {
      name: 'featured/:featuredCategoryId',
      route(classId: string, featuredCategoryId: string): string[] {
        return [...TEACHER_ROUTE.GAMESHOWS.route(classId), 'featured', featuredCategoryId];
      },
    },

    CUSTOM: {
      name: 'custom/:folderId',
      route(classId: string, folderId: string = ''): string[] {
        return [...TEACHER_ROUTE.GAMESHOWS.route(classId), 'custom', folderId];
      },
    }
  },

  GRADE_REPORT: {
    name: 'gradereport/:studentId',
    route(classId: string, studentId: string): string[] {
      return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), 'gradereport', studentId];
    }
  },

  GROWTH_REPORT: GROWTH_REPORT_ROUTE,

  HELP_CENTER: {
    name: 'HelpCenter',
    route(classId: string): string[] {
      return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), this.name];
    }
  },

  HELP_REQUESTS: HELP_REQUESTS_ROUTE,

  LIVE_MODE: LIVE_MODE_ROUTE,

  MATHALON: MATHALON_ROUTE,

  MISSION: {
    name: 'mission/:missionId',
    route(classId: string, missionId: string): string[] {
      return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), 'mission', missionId];
    },

    ADVANCED: {
      name: 'advanced',
      route(classId: string, missionId: string): string[] {
        return [...TEACHER_ROUTE.MISSION.route(classId, missionId), this.name];
      },
      queryParams(preassessment: string): Params {
        return {
          preassessment: preassessment
        };
      }
    },

    EDIT: {
      name: 'edit',
      route(classId: string, missionId: string): string[] {
        return [...TEACHER_ROUTE.MISSION.route(classId, missionId), this.name];
      }
    },

    INDIVIDUAL: {
      name: 'individual',
      route(classId: string, missionId: string): string[] {
        return [...TEACHER_ROUTE.MISSION.route(classId, missionId), this.name];
      },
      queryParams(preassessment: string): Params {
        return {
          from: encodeURI(preassessment),
        };
      }
    }
  },

  MISSIONS: {
    name: 'missions',
    route(classId: string): string[] {
      return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), this.name];
    },

    SHARED: {
      name: 'shared/:sharedFolderId/:folderId',
      route(classId: string, sharedFolderId: string, folderId: string): string[] {
        return [...TEACHER_ROUTE.MISSIONS.route(classId), 'shared', sharedFolderId, folderId];
      },
    }
  },

  MISSION_REPORT: MISSION_REPORT_ROUTE,

  MISSION_REPORT_EDIT_ROUTE: MISSION_REPORT_EDIT_ROUTE,

  DYNAMIC_MISSION_REPORT: DYNAMIC_MISSION_REPORT_ROUTE,

  PAPER_MODE: {
    name: 'papermode',
    route(classId: string): string[] {
      return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), this.name];
    }
  },
  PAPER_MODE_DOWNLOAD: {
    name: 'papermodedownload',
    route(classId: string): string[] {
      return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), this.name];
    }
  },

  PARENTS: PARENTS_ROUTE,

  PORTFOLIO: PORTFOLIO_ROUTE,

  REMEDIATION: {
    name: 'remediation/:logicalErrorId',
    route(classId: string, logicalErrorId: string): string[] {
      return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), "remediation", logicalErrorId];
    }
  },

  REPORTS: TEACHER_REPORTS_ROUTE,

  REFERRAL: {
    name: 'referral',
    route(classId: string): string[] {
      return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), this.name]
    }
  },

  STUDENTS: STUDENTS_ROUTE,

  STUDENT_GAP: STUDENT_GAP_ROUTE,

  STUDENT_GAPS: STUDENT_GAPS_ROUTE,

  STUDENT_SUMMARY: STUDENT_SUMMARY_ROUTE,

  ACTIVITY: {
    name: 'activity/:publicUnitId',
    route(publicUnitId: string): string[] {
      return [...TEACHER_ROUTE.route(), 'activity', publicUnitId];
    }
  },

  RECENT_ACTIVITY: RECENT_ACTIVITY_ROUTE,

  SEND_CHEER: SEND_CHEER_ROUTE,

  PRINT_QUESTION: {
    name: 'printquestion/:questionId',
    route(classId: string, questionId: string): string[] {
      return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), 'printquestion', questionId];
    }
  },

  REGISTER: {
    name: 'register',
    route(): string[] {
      return [...TEACHER_ROUTE.route(), this.name];
    },
    queryParams(email: string): { email: string } {
      return {
        email: encodeURI(email)
      };
    }
  }
};
